import React ,{useEffect} from 'react';
import {useNavigate} from 'react-router';
import CustomTable from '../../../components/CustomTable';
import {column} from './column';
import {getNewConsumableEntry} from '../../../@app/subMaster/subMasterSlice';
import {useDispatch, useSelector } from 'react-redux';

export default function ConsumableMaster({setTopTitle}) {
  setTopTitle('Consumable Entry Details');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const handleEditClick = (data) => {  
     navigate('/consumableEntryNew/addForm', {
      state: {...data,outlet_id:data?.outlet_id
      },      
    });
  };

  const { type, userData } = useSelector((state) => state.auth);
  useEffect(() => {
    if (type === 1)
      dispatch(getNewConsumableEntry({ path: "get-Consumable-Entry-New", data: {} }));
    else
      dispatch(
        getNewConsumableEntry({
          path: "get-Consumable-Entry-New",
          data: { employee: userData.data?.id }
        })
      );
  }, []); 

  const {
    gettingNewConsumableEntry,
    getNewConsumableEntryResponse: {data: dataSource}
  } = useSelector((state) => {
    return state.subMaster;
  });

  return (
    <CustomTable
      loading={gettingNewConsumableEntry}
      dataSource={dataSource}
      column={column}    
      handleEditClick={handleEditClick} 
      title={"Consumable Entry Details"}         
    />
  );
}
